import { render, staticRenderFns } from "./carAction.vue?vue&type=template&id=204988a3&scoped=true"
import script from "./carAction.vue?vue&type=script&lang=js"
export * from "./carAction.vue?vue&type=script&lang=js"
import style0 from "./carAction.vue?vue&type=style&index=0&id=204988a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204988a3",
  null
  
)

export default component.exports